import * as React from 'react';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';

import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle,
  TableRow, TableCell, Table, TableBody, Checkbox, TextField, LinearProgress
} from '@material-ui/core';

import ImportContactsIcon from '@material-ui/icons/ImportContacts';
import { QueryFilter, QUERY_FILTER_BESTSELLING} from 'src/component/shared';
import { client } from 'src';
import { CurrentDate, SomeDaysAgo } from 'src/services';
import { GoogleAnalytics, FilterCategoryType, MetricIndex } from "../../../../../services/GoogleAnalytics";

const ga = new GoogleAnalytics();

export interface IBestsellingProductFilterEntity {
    id: number;
    sku: string;
    description: string;
}

export interface IBestsellingProductFilterProps {
    endDate: any,
    filterType: number,
    initialDate: any,
}

// tslint:disable-next-line:no-empty-interface
export interface IBestsellingProductFilterState {
    dialogOpen: boolean,
    customFilter: {
        isChart: boolean,
        productName: string
    },
    bestsellingProductFilterChecked: string[],
    endDate: any,
    initialDate: any,
}

export const BESTSELLING_PRODUCT_FILTER = gql`
query bestsellingProductFilter($customFilter:  BookstoreCustomFilter) {
    bestsellingProductFilter(bookstoreCustomFilter: $customFilter) {
        id,
        sku,
		description
    }
    bestsellingProductFilterChecked @client
}
`;

export class BestsellingProductFilter extends React.Component<IBestsellingProductFilterProps, IBestsellingProductFilterState> {
    constructor(props: IBestsellingProductFilterProps) {
        super(props);

        this.state = {
            bestsellingProductFilterChecked: [],
            customFilter: {
                isChart: false,
                productName: '',
            },
            dialogOpen: false,
            endDate: undefined,
            initialDate: undefined,
        }
    }

    public componentWillMount () {

        let finalDate = this.props.endDate;
        if(finalDate==null || finalDate === undefined) {
            finalDate = CurrentDate();
        }
        let initDate = this.props.initialDate;
        if(initDate == null || initDate === undefined ) {
            initDate = SomeDaysAgo(7);
        }

        this.changeDate(initDate, finalDate);
    }

    public render() {

        const jsonFilter = {
            "customFilter": {
                "endDate": this.state.endDate,
                "filterType": this.props.filterType,
                "initialDate": this.state.initialDate,
                "isChart": this.state.customFilter.isChart,
                "productName": this.state.customFilter.productName,
            }
        };

        return (
            <Query query={QUERY_FILTER_BESTSELLING} notifyOnNetworkStatusChange={true}  >
                {({ loading: loadingC, error: errorC, data: cache, client: clientC}) => (
                    <Query query={BESTSELLING_PRODUCT_FILTER} partialRefetch={true} 
                        variables={QueryFilter.getFilterBestselling(clientC, jsonFilter, ['product'], false)}>
                        {({ loading, error, data, client: cliente}) => {

                            return (
                                <div className="filter-item">
                                    <Button variant="contained" onClick={this.handleDialogOpen}>
                                        <ImportContactsIcon className="filter-item-icon" /><div className="filter-label">Livros</div>
                                    </Button>
                                    <Dialog
                                        open={this.state.dialogOpen}
                                        onClose={this.handleDialogClose}
                                        aria-labelledby="book-filter-dialog-title"
                                        aria-describedby="book-filter-dialog-description"
                                        className="filter-dialog"
                                    >
                                        <DialogTitle className="filter-dialog-title" id="book-filter-dialog-title">{"Livros"}</DialogTitle>
                                        <DialogContent className="filter-dialog-content">
                                            <TextField
                                                id="filter-dialog-name"
                                                className="filter-dialog-input-name"
                                                label="Livros ou ISBN"
                                                value={this.state.customFilter.productName}
                                                onChange={this.handleChangeName}
                                                margin="normal"
                                            />
                                            {loading ? <LinearProgress /> : <Table >
                                                <TableBody>
                                                    {data && data.bestsellingProductFilter && data.bestsellingProductFilter.map((item: IBestsellingProductFilterEntity) => {
                                                        return (
                                                            <TableRow key={item.id}>
                                                                <TableCell component="th" scope="row">
                                                                <Checkbox
                                                                    checked={this.state.bestsellingProductFilterChecked.includes(item.id.toString())}
                                                                    onChange={this.handleChecked}
                                                                    autoFocus={true}
                                                                    value={item.id.toString()}
                                                                />
                                                                <span className="filter-dialog-item">{item.description} - {item.sku}</span>
                                                                </TableCell>
                                                            </TableRow>
                                                        );
                                                    })}
                                                </TableBody>
                                            </Table>}
                                        </DialogContent>
                                        <DialogActions className="filter-actions">
                                        <Button className="filter-dialog-clear" onClick={this.handleDialogClear} >
                                            Limpar
                                        </Button>
                                        <Button className="filter-dialog-close" onClick={this.handleDialogClose} >
                                            Fechar
                                        </Button>
                                        <Button className="filter-dialog-apply" onClick={this.handleDialogApply.bind(this, cliente)} autoFocus={true}>
                                            Aplicar
                                        </Button>
                                        </DialogActions>
                                    </Dialog>
                                </div>
                            )
                        }}
                    </Query>
                )}
            </Query>
        )
    }

    public changeDate (init: any, end: any) {
        this.setState({
            endDate: end,
            initialDate: init,
        });
    }

    private handleDialogOpen = () => {
        // tslint:disable-next-line:no-string-literal
        const checkAtual = client.cache['data'].data.ROOT_QUERY.FILTER_bestsellingProductFilterChecked.json;
        this.setState({ dialogOpen: true, bestsellingProductFilterChecked: checkAtual});
    };

    private handleDialogClose = () => {
        this.handleDialogClear();
        this.setState({ dialogOpen: false});
    };

  // tslint:disable-next-line:no-shadowed-variable
    private handleDialogApply = (client: any) => {

        client.writeData({ data: { bestsellingProductFilterChecked: this.state.bestsellingProductFilterChecked } });
        client.writeData({ data: { FILTER_bestsellingProductFilterChecked: this.state.bestsellingProductFilterChecked } });
        QueryFilter.updateMutationBestselling();
        if(this.state.bestsellingProductFilterChecked && this.state.bestsellingProductFilterChecked.length > 0) {
            const metricName = 'metric'+MetricIndex.FILTER;
            ga.fireEventTracking(FilterCategoryType.PRODUCT, 'filter', 'bestselling-product', false, metricName);
        }
        this.setState({ dialogOpen: false });

    }

    private handleDialogClear = () => {
        this.setState({
            bestsellingProductFilterChecked: [],
        customFilter: {
            isChart: false,
            productName: '',
        },
        });
    }

    private handleChangeName = (event: React.FormEvent<HTMLInputElement>) => {
        this.setState({
            customFilter: {
                isChart: false,
                productName: event.currentTarget.value,
            }
        });
    };

    private handleChecked = (event: React.FormEvent<HTMLInputElement>) => {
        let { bestsellingProductFilterChecked } = this.state;
        const { value } = event.currentTarget;

        if (bestsellingProductFilterChecked.includes(value)) {
            bestsellingProductFilterChecked = bestsellingProductFilterChecked.filter((item: string) => item !== value)
            this.setState({ bestsellingProductFilterChecked});
        } else {
            bestsellingProductFilterChecked = [...bestsellingProductFilterChecked, value];
            this.setState({ bestsellingProductFilterChecked});
        }

    }
}



// WEBPACK FOOTER //
// ./src/component/panel/shared/filter/bestselling-product-filter/BestsellingProductFilter.tsx